import { Action, StoreType } from 'reducers/types';
import { AVAILABLE_PROGRAMS_ACTION_TYPES } from 'actions/availablePrograms';
import { AvailableProgramsSource, AvailableProgramsState } from './types';

const initialState: AvailableProgramsState = {
  all: [],
  error: null,
  loading: false,
  loaded: false,
};

type AvailableProgramsPayload = AvailableProgramsSource & {
  error?: string;
};

export default function availableProgramsReducer(
  state = initialState,
  action: Action<AvailableProgramsPayload>,
): AvailableProgramsState {
  switch (action.type) {
    case AVAILABLE_PROGRAMS_ACTION_TYPES.LOADING:
      return {
        ...state,
        loading: true,
      };

    case AVAILABLE_PROGRAMS_ACTION_TYPES.LOADED:
      return {
        ...state,
        all: action.payload.programs,
        loading: false,
        loaded: true,
        error: null,
      };

    default:
      return state;
  }
}

export const getAvailablePrograms = (state: StoreType): AvailableProgramsState =>
  state.availablePrograms;
